"use client";

import { useSearchContext } from "./search.context";
import Suggestions from "./suggestions";

export default function NotFound() {
  const { search } = useSearchContext();

  if (search)
    return (
      <div className="flex w-4/5 flex-col items-center gap-4 px-4 py-8 md:max-w-[748px] lg:max-w-[849px]">
        <div className="w-fit">
          {/* {search.isRelated && (
            <p className="font-poppins text-xl font-medium md:text-2xl">
              Nenhum resultado encontrado
            </p>
          )} */}

          {/* {search.isRelated && !search?.cargos?.length && (
            <ul className="list-inside p-0">
              <li className="font-roboto text-sm font-normal md:text-base">
                Evite usar nomes abreviados
              </li>
              <li className="font-roboto text-sm font-normal md:text-base">
                Confira se as palavras estão corretas
              </li>
              <li className="font-roboto text-sm font-normal md:text-base">
                Refaça a busca com um termo mais genérico
              </li>
            </ul>
          )} */}

          {search.isRelated && (search?.cargos?.length ?? 0) > 0 && (
            <>
              <p className="font-poppins text-xl font-medium md:text-2xl">
                Nenhum resultado encontrado
              </p>

              <h3 className="my-6 text-base font-normal md:text-xl">
                Confira alguns cargos semelhantes
              </h3>

              <Suggestions suggestions={search?.cargos} />
            </>
          )}
        </div>
      </div>
    );

  return null;
}
